import { render, staticRenderFns } from "./scoreRoundDetailManage.vue?vue&type=template&id=f98cd7d4&scoped=true&"
import script from "./scoreRoundDetailManage.vue?vue&type=script&lang=ts&"
export * from "./scoreRoundDetailManage.vue?vue&type=script&lang=ts&"
import style0 from "./scoreRoundDetailManage.vue?vue&type=style&index=0&id=f98cd7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98cd7d4",
  null
  
)

export default component.exports